import type { ReferenceModalMode } from '@/app/stores/slices/reference-modal';
import { mergeCreationAndTask } from '@/app/utils';
import type { TitleSectionMode } from './components/TitleSection';
import type { ElementDetail, SubmitElementDetail, ViduV1Creation } from './types';

/**
 * 将 ReferenceModalMode 转换为 TitleSectionMode
 * ReferenceDetail 组件只在 view 和 post 模式下使用，edit 和 create 使用 ElementDialog
 */
export const toTitleSectionMode = (mode: ReferenceModalMode): TitleSectionMode => {
  if (mode === 'view' || mode === 'post') {
    return mode;
  }
  return null;
};

export const convertSubmitElementDetail2ElementDetail = (submitElementDetail: SubmitElementDetail): ElementDetail => {
  const { element, share } = submitElementDetail;
  const { id, name, components, recaption, version, voice, type, modality } = element || {};

  const {
    id: shareElementId,
    status: shareStatus,
    category,
    series,
    copy_count: shareCopyCount,
    use_count: shareUseCount,
    allow_copy: allowCopy,
    creator,
    introduce,
    creations,
    react_info: reactInfo,
    cid_to_task: cidToTask,
  } = share || {};

  return {
    id,
    name,
    components: components?.filter((it) => it.content || it.src_img),
    style: recaption?.style,
    description: recaption?.description,
    version,
    type,
    modality,
    shareElementId,
    shareStatus,
    shareCopyCount,
    shareUseCount,
    allowCopy,
    category,
    series,
    creator,
    introduce,
    voice,
    creations: creations?.map((it) => {
      return {
        ...mergeCreationAndTask({
          creation: it,
          task: cidToTask?.[it.id],
          creationId: it.id,
        }),
        creator: creator,
        created_at: it.created_at,
      };
    }),
    reactInfo,
  };
};

export const convertElementDetail2SubmitElementDetail = (elementDetail?: ElementDetail): SubmitElementDetail => {
  const {
    id,
    name,
    style,
    description,
    version,
    shareElementId,
    allowCopy,
    category,
    series,
    introduce,
    creations,
    voice,
  } = elementDetail || {};

  const result: SubmitElementDetail = {
    element: {
      id,
      name,
      recaption: {
        style,
        description,
      },
      version,
      voice,
      share_meta: {
        id: shareElementId,
      },
    },
  };

  result.share = {
    id: shareElementId,
    element_id: id,
    category,
    series,
    allow_copy: allowCopy,
    introduce,
    creations: (creations?.map((it) => {
      return {
        id: it.id,
      };
    }) || []) as ViduV1Creation[],
  };

  return result;
};

export const isAsciiStr = (str: string) => {
  return /^[\0-\x7F]+$/.test(str);
};
